"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankKey = void 0;
var BankKey;
(function (BankKey) {
    BankKey["ABBANK"] = "abbank";
    BankKey["ACB"] = "acb";
    BankKey["AGRIBANK"] = "agribank";
    BankKey["BAC_A_BANK"] = "bacabank";
    BankKey["BAOVIET_BANK"] = "baoviet";
    BankKey["BANVIET"] = "banviet";
    BankKey["BIDC"] = "bidc";
    BankKey["BIDV"] = "bidv";
    BankKey["CAKE"] = "cake";
    BankKey["CBBANK"] = "cbbank";
    BankKey["CIMB"] = "cimb";
    BankKey["COOP_BANK"] = "coopbank";
    BankKey["DBS_BANK"] = "dbsbank";
    BankKey["DONG_A_BANK"] = "dongabank";
    BankKey["EXIMBANK"] = "eximbank";
    BankKey["GPBANK"] = "gpbank";
    BankKey["HDBANK"] = "hdbank";
    BankKey["HONGLEONG_BANK"] = "hongleongbank";
    BankKey["HSBC"] = "hsbc";
    BankKey["IBK_HCM"] = "ibkhcm";
    BankKey["IBK_HN"] = "ibkhn";
    BankKey["INDOVINA_BANK"] = "indovinabank";
    BankKey["KASIKORN_BANK"] = "kasikorn";
    BankKey["KIENLONG_BANK"] = "kienlongbank";
    BankKey["KOOKMIN_BANK_HCM"] = "kookminhcm";
    BankKey["KOOKMIN_BANK_HN"] = "kookminhn";
    BankKey["LIENVIETPOST_BANK"] = "lienvietpostbank";
    BankKey["MBBANK"] = "mbbank";
    BankKey["MSB"] = "msb";
    BankKey["NAM_A_BANK"] = "namabank";
    BankKey["NCB"] = "ncb";
    BankKey["NONGHYUP_BANK_HN"] = "nonghyup";
    BankKey["OCB"] = "ocb";
    BankKey["OCEANBANK"] = "oceanbank";
    BankKey["PGBANK"] = "pgbank";
    BankKey["PUBLIC_BANK"] = "publicbank";
    BankKey["PVCOM_BANK"] = "pvcombank";
    BankKey["SACOMBANK"] = "sacombank";
    BankKey["SAIGONBANK"] = "saigonbank";
    BankKey["SCB"] = "scb";
    BankKey["SEA_BANK"] = "seabank";
    BankKey["SHB"] = "shb";
    BankKey["SHINHAN_BANK"] = "shinhanbank";
    BankKey["STANDARD_CHARTERED_BANK"] = "standardcharteredbank";
    BankKey["TECHCOMBANK"] = "techcombank";
    BankKey["TIMO"] = "timo";
    BankKey["TPBANK"] = "tpbank";
    BankKey["UBANK"] = "ubank";
    BankKey["UNITED_OVERSEAS_BANK"] = "uob";
    BankKey["VIB"] = "vib";
    BankKey["VIET_A_BANK"] = "vietabank";
    BankKey["VIET_BANK"] = "vietbank";
    BankKey["VIETCOMBANK"] = "vietcombank";
    BankKey["VIETINBANK"] = "vietinbank";
    BankKey["VPBANK"] = "vpbank";
    BankKey["VRB"] = "vrb";
    BankKey["WOORI_BANK"] = "wooribank";
})(BankKey = exports.BankKey || (exports.BankKey = {}));
